import { render } from "./ButtonCreate.vue?vue&type=template&id=28bd9b3c"
import script from "./ButtonCreate.vue?vue&type=script&lang=js"
export * from "./ButtonCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__